import React from "react";
import { Button, Modal } from "react-bootstrap";

import classNames from "classnames";

import { ProductModalProps } from "@LeagueManagement/Order/types/order";

const CancelProductModal = ({
    show,
    product,
    handleClose,
    handleSubmit,
}: ProductModalProps): React.JSX.Element => {
    return (
        <Modal show={show} onHide={handleClose} centered>
            <Modal.Header>
                <Modal.Title className={classNames("text-center")}>
                    Are you show you want to cancel this registration?
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <h6>Registration Info:</h6>
                <dl className={classNames("inline")}>
                    <dt>League:</dt>
                    <dd>{product.description}</dd>
                    {product.meta.teamName && (
                        <>
                            <dt>Team:</dt>
                            <dd>{product.meta.teamName}</dd>
                        </>
                    )}
                </dl>
                <p className={classNames("mb-0")}>
                    Cancelling the registration will:
                </p>
                <ul>
                    <li>
                        Cancel <b>this</b> league registration.
                    </li>
                    <li>
                        Update the number of open spots in this league (if
                        applicable)
                    </li>
                </ul>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="primary" onClick={handleClose}>
                    No
                </Button>
                <Button
                    variant="danger"
                    onClick={() => {
                        handleSubmit("product", handleClose, {
                            productId: product.id,
                            teamId: product.meta.teamId!,
                        });
                    }}
                >
                    Yes
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default CancelProductModal;
